module.exports = __webpack_public_path__ + "img/avatar4.f5ce3284.png";